import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "", y = 24 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.7, delay, ease: [0.16, 1, 0.3, 1] }}
  >
    {children}
  </motion.div>
);

export const SectionHeading = ({ eyebrow, title, sub, testid }) => (
  <div className="max-w-3xl">
    <Reveal>
      <p className="font-mono text-xs font-medium uppercase tracking-[0.25em] text-brand-amber" data-testid={`${testid}-eyebrow`}>
        {eyebrow}
      </p>
    </Reveal>
    <Reveal delay={0.08}>
      <h2 className="mt-4 font-heading text-2xl font-bold tracking-tight text-navy sm:text-3xl lg:text-4xl" data-testid={`${testid}-title`}>
        {title}
      </h2>
    </Reveal>
    {sub && (
      <Reveal delay={0.16}>
        <p className="mt-4 text-base leading-relaxed text-slate-600 sm:text-lg" data-testid={`${testid}-sub`}>
          {sub}
        </p>
      </Reveal>
    )}
  </div>
);
